import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

export const CertificateApiSlice = createApi({
  reducerPath: "certificateApi",
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    addCertificate: builder.mutation({
      query: (body): any => {
        return {
          url: `/certificate/add`,
          method: "POST",
          body: body
        };
      },
      extraOptions: { service: "Widget" }
    }),
    certificateData: builder.query({
      query: ({ parenttype, parentid }) => ({
        url: `/certificate/${parenttype}/${parentid}`,
        method: "GET"
      }),
      extraOptions: { service: "Widget" }
    }),
    fetchMyCertificate: builder.query({
      query: ({
        pageNumber,
        pageSize,
        userId,
        requiredQuery = `data {
                totalCount
                pageNumber
                pageSize
                myCertificateList {
                  id
                  title
                  artifactId
                  artifactType
                  downloadable
                  parentId
                  parentType
                  archived
                  certificateUrl
                  externalCertificateId
                  expiryDate
                  createdat
                  parentDetails {
                            id
                            title
                            shortDescription
                            sourcename
                            sourcetype
                          }
                }
              }`
      }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchMyCertificate(
              filter: {
                pageNumber: ${pageNumber}
                pageSize: ${pageSize}
                sortKey: "createdat"
                sortOrder: "dsc"
                ${userId ? `userId: "${userId}"` : ""}
              }
            ) {
              ${requiredQuery}
            }
          }
        `
      }),
      extraOptions: { service: "Widget" },
      serializeQueryArgs: ({ queryArgs }) => {
        const { pageSize, requiredQuery, userId } = queryArgs;
        return JSON.stringify({ pageSize, requiredQuery, userId });
      },
      forceRefetch: ({ currentArg, previousArg }) =>
        currentArg?.pageNumber !== previousArg?.pageNumber ||
        currentArg?.userId !== previousArg?.userId,
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.pageNumber > 1) {
          const certificateMap = new Map();
          [
            ...(currentCacheData?.fetchMyCertificate?.data?.myCertificateList ??
              []),
            ...responseData.fetchMyCertificate.data.myCertificateList
          ].forEach((certificate) => {
            if (!certificateMap.has(certificate.id)) {
              certificateMap.set(certificate.id, certificate);
            }
          });
          return {
            ...responseData,
            fetchMyCertificate: {
              ...responseData.fetchMyCertificate,
              data: {
                ...responseData.fetchMyCertificate.data,
                myCertificateList: [...certificateMap.values()]
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useAddCertificateMutation,
  useLazyCertificateDataQuery,
  useFetchMyCertificateQuery,
  useLazyFetchMyCertificateQuery
} = CertificateApiSlice;
